const PORTFOLIO_ALLOWLIST = ["tkhongfpt@gmail.com", "ktrangkhong0402@gmail.com"];

export function isPortfolioViewer(email?: string | null): boolean {
  if (!email) return false;
  return PORTFOLIO_ALLOWLIST.includes(email.trim().toLowerCase());
}
